import Axios from "API/Axios";
import { AxiosMethodEnum } from "API/Axios";
import { Axios_Route } from "API/AxiosRouts";
import React, { useEffect, useState, FormEvent } from "react";
import { ValidationErrorMessages } from "utils/Error";
import { notify, ToastType } from "utils/Toast";
import { phoneNumberCheck } from "utils/rejex";
import { useNavigate } from "react-router-dom";
import { URL_Route } from "urlRouts";
import { emailCheck } from "utils/rejex";
import ImageCompress from "utils/ImageCompress";

interface Props {
  Component: any;
}

export interface Error {
  name: string | null;
  mobile: string | null;
  role: string | null;
  email: string | null;
  active: string | null;
}

const AddAgent: React.FC<Props> = ({ Component }) => {
  const [name, setName] = useState<string>("");
  const [mobile, setMobile] = useState<string>("");
  const [role, setRole] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [active, setActive] = useState<string>("");
  const [roleList, setRoleList] = useState<any>([]);
  const [activeList, setActiveList] = useState<any>([]);
  const [error, setError] = useState<Error>({
    name: null,
    mobile: null,
    role: null,
    email: null,
    active: null,
  });
  const [showErrors, setShowErrors] = useState<boolean>(false);
  const [allowToAdd, setAllowToAdd] = useState<boolean>(true);
  const [imageUploadedUrl, setImageUploadedUrl] = useState<string>("");
  const [imageSelectForCrop, setImageSelectForCrop] = useState<any>(null);
  const [imageSelectedName, setImageSelectedName] = useState<string>('');
  const [finalImage, setFinalImage] = useState<string | null>(null);
  const [showModalCrop, setShowModalCrop] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setActiveList([
      { id: 1, title: "Active" },
      { id: 2, title: "Not Active" },
    ]);

    Axios(AxiosMethodEnum.get, Axios_Route.GET_USER_ROLE).then(
      ({ response, success }) => {
        if (success) {
          setRoleList(response);
        }
      }
    );
  }, []);

  useEffect(() => {
    if (showErrors) {
      errorHandling();
    }
  }, [name, mobile, role, email, active]);

  const errorHandling = () => {
    let AllowToContinue = true;

    if (name.length === 0) {
      error.name = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.name = null;
    }

    if (mobile.length === 0) {
      error.mobile = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.mobile = null;
    }

    if (!phoneNumberCheck(mobile)) {
      error.mobile = ValidationErrorMessages.ERRORS.MOBILE_VALIDATION_ERROR;
      AllowToContinue = false;
    } else {
      error.mobile = null;
    }

    if (role.length === 0) {
      error.role = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.role = null;
    }

    if (!emailCheck(email) && email.length !== 0) {
      error.email = ValidationErrorMessages.ERRORS.EMAIL_FORMAT_NOT_VALID;
      AllowToContinue = false;
    } else {
      error.email = null;
    }

    if (active.length === 0) {
      error.active = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.active = null;
    }

    setError({ ...error });

    return AllowToContinue;
  };

  const addAgentHandler = (e: FormEvent) => {
    e.preventDefault();

    setShowErrors(true);
    let AllowToContinue = errorHandling();

    if (!AllowToContinue) {
      window.scrollTo({ top: 0 });
      notify(
        Object.values(error).find((index) => index !== null),
        ToastType.error
      );
    }
    
    if (AllowToContinue && allowToAdd) {
      setAllowToAdd(false);
      const AddAgentObj = {
        fullName: name,
        imageURL: imageUploadedUrl,
        isActive: active.toString() === "1" ? true : false,
        mobile: mobile,
        pageNumber: 1,
        roleId: role,
        email: email,
        roleName: roleList.find((item: any) => item.id === role).title,
      };
      Axios(AxiosMethodEnum.post, Axios_Route.ADD_USER, AddAgentObj).then(
        ({ response, success }) => {
          setAllowToAdd(true);
          if (success) {
            notify(
              ValidationErrorMessages.SUCCESS.AGENT_ADDED,
              ToastType.success
            );
            navigate(URL_Route.List_Agent);
          } else if (!success) {
            notify(response.message, ToastType.error);
          }
        }
      );
    }
  };

  function DataURIToBlob(dataURI: string) {
    const splitDataURI = dataURI.split(",");
    const byteString =
      splitDataURI[0].indexOf("base64") >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(":")[1].split(";")[0];

    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i);

    return new Blob([ia], { type: mimeString });
  }

  const uploadImageFunc = (imgBase64: any) => {
    const File = DataURIToBlob(imgBase64);
    
    const formData = new FormData();
    formData.append("image", File, imageSelectedName);
    Axios(
      AxiosMethodEnum.post,
      Axios_Route.UPLOAD_USER_IMAGE,
      formData,
      "multipart/form-data"
    ).then(({ response, success }) => {
      setAllowToAdd(true);
      if (success) {
        setImageUploadedUrl(response);
        notify(
          ValidationErrorMessages.SUCCESS.IMAGE_UPLOADED_SUCCESSFULLY,
          ToastType.success
        );
      } else if (!success) {
        setImageSelectedName('')
        setImageSelectForCrop('')
        setImageUploadedUrl("");
        notify(response.error, ToastType.error);
      }
    });
  };

  async function handleSelectImage (e: any) {
    if (e.target.files && e.target.files.length > 0) {
      let result:any = await ImageCompress(e.target.files[0],false);
      if (result === false) {
        return
      }

      const reader = new FileReader();
      setImageSelectedName(e.target.files[0].name)
      reader.readAsDataURL(result);
      reader.onload = function (e) {
        setImageSelectForCrop(reader.result);
        setShowModalCrop(true);
      };
    }
  };

  const removeImageFunc = (sortNumber: number) => {
    setFinalImage("");
  };

  const onCropDone = (imgCroppedArea: any) => {
    const canvasEle = document.createElement("canvas");
    canvasEle.width = imgCroppedArea.width;
    canvasEle.height = imgCroppedArea.height;

    const context: any = canvasEle.getContext("2d");

    let imageObj1 = new Image();
    imageObj1.src = imageSelectForCrop;
    imageObj1.onload = function () {
      context.drawImage(
        imageObj1,
        imgCroppedArea.x,
        imgCroppedArea.y,
        imgCroppedArea.width,
        imgCroppedArea.height,
        0,
        0,
        imgCroppedArea.width,
        imgCroppedArea.height
      );

      const dataURL = canvasEle.toDataURL("image/jpeg");

      setFinalImage(dataURL);
      setShowModalCrop(false);
      uploadImageFunc(dataURL);
    };
  };

  const onCropCancel = () => {
    setShowModalCrop(false);
    setImageSelectForCrop(null);
  };

  return (
    <div>
      <Component
        addAgentHandler={addAgentHandler}
        name={name}
        setName={setName}
        mobile={mobile}
        setMobile={setMobile}
        role={role}
        setRole={setRole}
        roleList={roleList}
        email={email}
        setEmail={setEmail}
        setActive={setActive}
        activeList={activeList}
        error={error}
        handleSelectImage={handleSelectImage}
        showModalCrop={showModalCrop}
        setShowModalCrop={setShowModalCrop}
        imageSelectForCrop={imageSelectForCrop}
        onCropDone={onCropDone}
        onCropCancel={onCropCancel}
        finalImage={finalImage}
        removeImageFunc={removeImageFunc}
      />
    </div>
  );
};

export default AddAgent;
